/** 사이드바 메인 메뉴 */
export const SidebarMajorList = [
  // { name: '테스트', path: '/', key: 5 },
  // { name: '대시보드', path: '/dash-board', key: 0 },
  { name: '주문관리', key: 1 },
  { name: '생산관리', path: '', key: 2 },
  { name: '기초등록', path: '', key: 3 },
  { name: '엑셀변환 정보 등록', path: '', key: 6 },
  { name: '배송', path: '', key: 4 },
  { name: '데이터관리', path: '', key: 5 },
  { name: '분석', path: '', key: 7 },
  // { name: '기타', path: '', key: 8 },
];

/** 사이드바 메인 메뉴에 따르는 서브메뉴 */
export const SidebarMinorList: Record<
  number,
  { name: string; path: string }[]
> = {
  0: [],
  1: [
    { name: '주문조회', path: '/orders' },
    { name: '주문등록', path: '/orders/update' },
    { name: '주문 배송지 미등록 항목', path: '/orders/address-verify' },
    { name: '자사쇼핑몰 주문 변경내역', path: '/orders/emm-shop-changed' },
  ],
  2: [
    { name: '생산등록', path: '/production-add' },
    { name: '생산현황', path: '/production-overview' },
    { name: '생산진행', path: '/production-progress' },
    { name: '생산입고', path: '/production-inbound' },
    { name: '재고현황', path: '/stock' },
    { name: '기계등록', path: '/machine' },
    { name: '기계배정', path: '/machine-assignment' },
    { name: '소모품 이력', path: '/stock-history-log' },
  ],
  3: [
    { name: '거래처 정보등록', path: '/trader/update' },
    { name: '소모량 등록', path: '/bom' },
    // { name: '거래처 약칭 등록', path: '/trader/abbreviation' },
    // { name: '품목 약칭 등록', path: '/item/abbreviation' },
  ],
  4: [
    { name: '배송묶음', path: '/delivery/set' },
    { name: '배송조회', path: '/delivery/list' },
    { name: '택배송장변환', path: '/parcel' },
  ],
  5: [{ name: '근태관리 엑셀변환', path: '/attendance' }],
  6: [
    { name: '품목 택배정보 등록', path: '/parcel-item' },
    { name: '거래처 택배정보 등록', path: '/parcel-trader' },
  ],
  7: [
    { name: '시각데이터', path: '/analysis/chart' },
    { name: '기간별 주문데이터 조회', path: '/analysis/order-statistics' },
    {
      name: '잠재고객 주문데이터 조회',
      path: '/analysis/potential-customer-orders',
    },
  ],
  // 8: [{ name: '문의', path: '/inquiries' }],
};

/** 사이드바 메인 메뉴 - 어드민 */
export const SidebarAdminMajorList = [
  { name: '계정관리', path: '/account-manage', key: 0 },
  { name: '데이터관리', path: '/data-manage', key: 1 },
  { name: '스케줄러 관리', path: '/scheduler-manage', key: 2 },
  // { name: '문의', path: '/inquiries', key: 3 },
  // { name: '주문관리', key: 1 },
];

/** 사이드바 메인 메뉴에 따르는 서브메뉴 - 어드민 */
export const SidebarAdminMinorList: Record<
  number,
  { name: string; path: string }[]
> = {
  0: [
    // { name: '계정등록', path: '/account-add' },
    // { name: '계정삭제', path: '/account-delete' },
  ],
  1: [],
  // 1: [{ name: '주문등록', path: '/orders/update' }],
};

//엑세스바 모드를 타입으로 export
const customBarModes = ['BOARD'];
export type CustomBarMode = (typeof customBarModes)[number];

export const DELIVERY_TPYE = ['전체', '직배', '화물', '택배', '방문'];
export const DELIVERY_ORDER = ['가까운 날짜순', '먼 날짜순'];
